import React, { useState, useEffect, useCallback, useContext } from "react";
import { EmployeeNavbar } from "./reusedcomponent/navbar";
import { AuthContext } from "../../../Context/AuthContext";
import ViewDetailModal from "./modals/view_details";
import { ApiService } from "../../../services/ApiService";
import { useAlert } from "react-alert";
import { ConfirmTemplate } from "../../../components/confirm";
import { Link } from "react-router-dom";
import { constant } from "../../../Constants/constant";
import Modal from "react-modal";
import { employeeMngtThunk } from "../../../store/actions/employeemanagement/employee.thunk";
import { useDispatch, useSelector } from "react-redux";
import { PageBody } from "../../../components/loader";
import { useLoadingMessage } from "../../../components/useLoadingMessage";
import { capitalize } from "../../../utils/capitalize";
import ViewLeaveSummary from "./modals/view_leave_summary";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const customStyles = {
  content: {
    top: "40%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-60%",
    transform: "translate(-50%, -50%)",
    overflow: "scroll",
    width: "1000px",
    height: "100vh",

    // border: "2px solid green",
  },
};

const customStyles2 = {
  content: {
    top: "40%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-60%",
    transform: "translate(-50%, -50%)",
    overflow: "scroll",

    // border: "2px solid green",
  },
};

Modal.setAppElement("#root");

export const EmployeeIndex = () => {
  const alert = useAlert();
  const [modalopen, Setmodalopen] = useState(false);
  const { user } = useContext(AuthContext);
  const [employee, setEmployee] = useState();
  const [employeeLeave, setEmployeeLeave] = useState();
  const { isLoading, message, updateLoader } = useLoadingMessage();
  // const { modalIsOpen, openModal, closeModal } = useModal();
  const { employees } = useSelector((state) => state.employeeMngt);
  const dispatch = useDispatch();

  const [modalIsOpen, setIsOpen] = useState(false);

  const [leaveModalIsOpen, setLeaveModalOpen] = useState(false);

  // const openModal = () => {
  //   setIsOpen(true);
  // };

  const closeModal = () => {
    setIsOpen(false);
  };

  const closeLeaveModal = () => {
    setLeaveModalOpen(false);
  };

  const [showList, setList] = useState(false);
  const toggleView = () => {
    setList(!showList);
  };

  function toggle() {
    Setmodalopen(!modalopen);
  }

  const deActivate = (slug, id) => {
    const request = async () => {
      const user_id = {
        slug: slug,
      };
      const res = await ApiService.post(`users/deactivate/${slug}`, user_id);
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        getEmployeesDetails();
      }
    };

    ConfirmTemplate(
      {
        title: "Change user status",
        message: "Are You Sure You Want To Change This User Status",
      },
      request
    );
  };

  const Activate = (slug, id) => {
    const request = async () => {
      const user_id = {
        slug: slug,
      };
      const res = await ApiService.post(`users/activate/${slug}`, user_id);
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        getEmployeesDetails();
      }
    };

    ConfirmTemplate(
      {
        title: "Change user status",
        message: "Are You Sure You Want To Change This User Status",
      },
      request
    );
  };

  const getEmployeesDetails = useCallback(async () => {
    updateLoader(true, "Getting all employees");
    await dispatch(employeeMngtThunk.getEmployeesDetails());
    updateLoader(false);
  }, [dispatch]);

  useEffect(() => {
    getEmployeesDetails();
  }, []);

  return (
    <React.Fragment>
      <PageBody isLoading={isLoading} message={message}>
        <EmployeeNavbar toggle={toggleView} show={showList} />
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="view user datails modal"
        >
          <ViewDetailModal closeModal={closeModal} user={employee} />
        </Modal>

        <Modal
          isOpen={leaveModalIsOpen}
          onRequestClose={closeLeaveModal}
          style={customStyles2}
          contentLabel="view user leave modal"
        >
          <ViewLeaveSummary closeModal={closeLeaveModal} user={employeeLeave} />
        </Modal>

        {!showList ? (
          <div className="grid">
            <div className="row container">
              {employees.map((employee, i) => (
                <div className="col-md-3" key={i}>
                  <div className="text-center card-box-two">
                    {(user.data.user.roles &&
                      user.data.user.roles.name === "admin") ||
                    user.data.user.roles.name === "human resource" ? (
                      <div className="dropdown pull-right">
                        <a
                          href="employee-management.html#"
                          className="dropdown-toggle card-drop arrow-none"
                          data-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <h3 className="m-0 text-muted">
                            <i className="fas fa-ellipsis-v"></i>
                          </h3>
                        </a>

                        <div
                          className="dropdown-menu dropdown-menu-right"
                          aria-labelledby="btnGroupDrop1"
                        >
                          <Link
                            to={`/dashboard/employee/edit/${employee.slug}`}
                            className="dropdown-item"
                          >
                            Edit
                          </Link>
                          <button
                            className="dropdown-item"
                            onClick={() => {
                              setLeaveModalOpen(true);
                              setEmployeeLeave(employee);
                            }}
                          >
                            View Leave Summary
                          </button>
                          {employee.is_active == 1 ? (
                            <button
                              className="dropdown-item"
                              onClick={() => {
                                deActivate(employee.slug, employee.id);
                              }}
                            >
                              Deactivate
                            </button>
                          ) : null}

                          {employee.is_active == 0 ? (
                            <button
                              className="dropdown-item"
                              onClick={() => {
                                Activate(employee.slug, employee.id);
                              }}
                            >
                              Activate
                            </button>
                          ) : null}
                        </div>
                      </div>
                    ) : null}

                    <div className="clearfix"></div>
                    <div className="member-card">
                      <div className="thumb-xl member-thumb m-b-10 mx-auto">
                        <img
                          height="100px"
                          width="100px"
                          src={`${constant.ImgURL}profile_pictures/uploads/${employee.profile_picture}`}
                          className="rounded-circle border-2"
                          alt="profile"
                        />
                        <i
                          className="mdi mdi-star-circle member-star text-success"
                          title="verified user"
                        ></i>
                      </div>

                      <div className="">
                        <h4 className="m-b-5 font-18">
                          {capitalize(employee.first_name) +
                            " " +
                            capitalize(employee.last_name)}
                        </h4>
                        <p className="text-muted">
                          {employee.job_title !== null
                            ? capitalize(employee.job_title.name)
                            : ""}{" "}
                          <span> || </span>{" "}
                          <span> {capitalize(employee.office)}</span>
                        </p>
                      </div>

                      <p className="text-muted font-13">
                        {employee.mobile_number}
                      </p>
                      <p className="text-muted font-13">
                        {employee.is_active ? "Active" : "Inactive"}{" "}
                      </p>

                      {(user.data.user.roles &&
                        user.data.user.roles.name === "admin") ||
                      user.data.user.roles.name === "human resource" ? (
                        <button
                          type="button"
                          className="btn btn-primary m-t-20 btn-rounded btn-bordered waves-effect w-md waves-light"
                          onClick={() => {
                            setIsOpen(true);
                            setEmployee(employee);
                          }}
                        >
                          View details
                        </button>
                      ) : null}
                      {/* </a> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="list row container">
            <div className="mb-3 clearfix">
              <div
                class="btn-group float-left"
                role="group"
                aria-label="Basic example"
              >
                <button
                  type="button"
                  class="btn btn-secondary btn-group-sm"
                  onClick={() => window.print()}
                >
                  Print
                </button>
                <ReactHTMLTableToExcel
                  id="test-table-xls-button"
                  className="btn btn-secondary btn-group-sm"
                  table="employee-table"
                  filename="EMPLOYEES"
                  sheet="tablexls"
                  buttonText="Export to excel"
                />
              </div>
            </div>
            <table
              id="employee-table"
              className="table table-bordered asset-table table-disciplinary-case dtMaterialDesignExample"
            >
              <thead>
                <tr>
                  <th>NO</th>
                  <th className="th-sm">NAME</th>
                  <th className="th-sm">JOB TITLE</th>
                  <th className="th-sm">OFFICE</th>
                  <th className="th-sm">EMAIL</th>
                  <th className="th-sm">STATUS</th>
                  <th className="th-sm"></th>
                </tr>
              </thead>
              <tbody>
                {employees.map((employee, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>
                      {capitalize(employee.first_name) +
                        " " +
                        capitalize(employee.last_name)}{" "}
                    </td>
                    <td> {employee.roles.name} </td>
                    <td>{employee.office} </td>
                    <td>{employee.email} </td>
                    <td> {employee.is_active ? "Active" : "Inactive"} </td>
                    <td>
                      {(user.data.user.roles &&
                        user.data.user.roles.name === "admin") ||
                      user.data.user.roles.name === "human resource" ? (
                        <div className="dropdown pull-right">
                          <a
                            href="employee-management.html#"
                            className="dropdown-toggle card-drop arrow-none"
                            data-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <h3 className="m-0 text-muted">
                              <i className="fas fa-ellipsis-v"></i>
                            </h3>
                          </a>

                          <div
                            className="dropdown-menu dropdown-menu-right"
                            aria-labelledby="btnGroupDrop1"
                          >
                            <Link
                              to={`/dashboard/employee/edit/${employee.slug}`}
                              className="dropdown-item"
                            >
                              Edit
                            </Link>
                            <button
                              className="dropdown-item"
                              onClick={() => {
                                deActivate(employee.slug, employee.id);
                              }}
                            >
                              {employee.is_active ? "Activate" : "Deactivate"}
                            </button>
                          </div>
                        </div>
                      ) : null}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </PageBody>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/employeemanagement/index.js